export var isEqual = function isEqual(a, b) {
  return !a && !b || a && b && a.year === b.year && a.month === b.month && a.date === b.date;
};
export var comparator = function comparator(a, b) {
  if (a.year < b.year) {
    return -1;
  } else if (a.year > b.year) {
    return 1;
  } else if (a.month < b.month) {
    return -1;
  } else if (a.month > b.month) {
    return 1;
  } else if (a.date < b.date) {
    return -1;
  } else if (a.date > b.date) {
    return 1;
  }

  return 0;
};
export var create = function create(date, month, year) {
  return {
    date: date,
    month: month,
    year: year
  };
};
export var isLess = function isLess(left, right) {
  return comparator(left, right) === -1;
};
export var isLessOrEqual = function isLessOrEqual(left, right) {
  return isLess(left, right) || isEqual(left, right);
};
export var isGreater = function isGreater(left, right) {
  return !isLessOrEqual(left, right);
};
export var isGreaterOrEqual = function isGreaterOrEqual(left, right) {
  return !isLess(left, right);
};
export var isBetween = function isBetween(date, left, right) {
  if (left && isLess(date, left)) {
    return false;
  }

  if (right && isGreater(date, right)) {
    return false;
  }

  return true;
};